/**
 * Components
 */
const files = require.context('./components/', true, /\.vue$/i)

files.keys().map((key, value) => {
    Vue.component(key.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase().split('/').pop().split('.')[0], files(key).default)
})